<template>
  <div class="right_col" role="main">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('subMenu.menu') }}({{ pageDescription }})</h3>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="x_panel">
            <div class="x_content">
              <alert
                :title="$t('orderPage.menuConfig')"
                :success-message="$t('common.hasRegistered')"
                :error-message="$t('common.hasNotRegistered')"
                :alerts="alerts"
                :errors="errors"
                :display="isSuccess"
                @closeAlert="closeAlert"
              />

              <div class="row">
                <div class="col-md-4">
                  <div class="text-left">
                    <label class="control-label" for="startAt"
                      >{{ $t('orderPage.useStartTime') }}
                      <template v-if="!isJp">({{ timezone }})</template>
                      <span class="required">*</span>：</label
                    >
                    <input
                      id="startAt"
                      v-model="startAt"
                      :disabled="editDisabled"
                      step="1"
                      type="datetime-local"
                    />
                  </div>
                  <br />
                  <div class="text-left">
                    <label class="control-label" for="endAt"
                      >{{ $t('orderPage.useEndTime') }}
                      <template v-if="!isJp">({{ timezone }})</template>
                      <span class="required">*</span>：</label
                    >
                    <input
                      id="endAt"
                      v-model="endAt"
                      step="1"
                      type="datetime-local"
                    />
                  </div>
                </div>
                <div class="col-md-3 form-inline">
                  <label class="control-label"
                    >{{ $t('orderPage.menuStatus') }}
                    <span class="required">*</span></label
                  ><br />
                  <div class="form-group" style="margin-right: 20px">
                    <label class="control-label" for="draft"
                      >{{ $t('orderPage.draft') }}：</label
                    >
                    <input
                      id="draft"
                      v-model="menuStatus"
                      :disabled="editDisabled"
                      type="radio"
                      class="flat form-control"
                      name="status"
                      value="1"
                      checked
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="production"
                      >{{ $t('orderPage.inOperation') }}：</label
                    >
                    <input
                      id="production"
                      v-model="menuStatus"
                      :disabled="editDisabled"
                      type="radio"
                      class="flat form-control"
                      name="status"
                      value="2"
                    />
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="text-right">
                    <router-link to="/order/menu/csv" class="btn btn-primary">{{
                      $t('common.csvUpload')
                    }}</router-link>
                    <a
                      :href="csvURL"
                      :download="csvFileName"
                      @click="csvDownLoad"
                      class="btn btn-default"
                      >{{ $t('common.csvDownload') }}</a
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="text-right">
                  <button
                    id="btn-preview"
                    @click="showPreviewModal"
                    class="btn btn-primary"
                  >
                    {{ $t('orderPage.preview') }}
                  </button>
                </div>
              </div>
              <div class="" role="tabpanel" data-example-id="togglable-tabs">
                <ul id="myTab" class="nav nav-tabs bar_tabs" role="tablist">
                  <li
                    v-for="(category, key) in categories"
                    :key="key"
                    :class="{
                      active: category.categoryCode == currentCategoryCode,
                    }"
                    @click="updateCurrentCategory(category.categoryCode)"
                    role="presentation"
                  >
                    <a
                      :class="{
                        bbn: category.categoryCode == currentCategoryCode,
                      }"
                      href="#"
                    >
                      {{
                        category.names[language] ||
                          category.names[defaultLanguage]
                      }}
                    </a>
                  </li>
                </ul>
                <div id="myTabContent" class="tab-content">
                  <div
                    id="tab_content1"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div class="text-right">
                      <button
                        id="item_add"
                        @click="showItemSelectModal"
                        class="btn btn-primary"
                      >
                        {{ $t('common.add') }}
                      </button>
                    </div>
                    <menu-table :column-titles="tableHeaderColumns" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right">
              <a
                id="btn-submit"
                @click="submit"
                class="btn btn-primary"
                href="#"
                >{{ $t('common.save') }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <menu-preview :class="{ 'is-open': isShowPreviewModal }" class="p-modal" />
    <menu-modal :class="{ 'is-open': isShowItemSelectModal }" class="p-modal" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Papa from 'papaparse'

import { getTimezone } from '@/utility/time'
// components
import MenuTable from '@/views/order/menu/MenuTable'
import MenuModal from '@/views/order/menu/MenuModal'
import MenuPreview from '@/components/menuPreviewModal/MenuPreview'
import Alert from '@/components/common/alert/Alert'
// module
import config from '@/config/config'
import MenuRequest from '@/http/MenuRequest'

export default {
  components: {
    MenuTable,
    MenuModal,
    MenuPreview,
    Alert,
  },
  data() {
    return {
      tableHeaderColumns: [
        this.$t('common.itemCode'),
        this.$t('common.itemName'),
        this.$t('orderPage.menuDisplay'),
        this.$t('orderPage.wideDisplay'),
        this.$t('common.delete'),
      ],
      startAt: '',
      endAt: '',
      menuStatus: null, // メニューの状態 1=下書き,2=運用中
      isSuccess: false,
      errors: null,
      alerts: '',
      editDisabled: false,
      csvURL: '',
      csvFileName: '',
    }
  },
  computed: {
    ...mapGetters({
      categories: 'menu/getCategories',
      items: 'menu/getItems',
      draftMenu: 'menu/getDraftMenu',
      inOperationMenu: 'menu/getInOperationMenu',
      currentCategoryCode: 'menu/getCurrentCategoryCode',
      isShowItemSelectModal: 'menu/getIsShowItemSelectModal',
      isShowPreviewModal: 'menu/getIsShowPreviewModal',
      displayMode: 'menu/getDisplayMode',
      language: 'settings/getLanguage',
      defaultLanguage: 'settings/getDefaultLanguage',
    }),
    isCreate() {
      return this.$route.name === 'menuCreate'
    },
    menu() {
      return this.isCreate ? this.draftMenu : this.inOperationMenu
    },
    pageDescription() {
      return this.isCreate
        ? this.$t('orderPage.editingDraft')
        : this.$t('orderPage.editingTheMenuInOperation')
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    timezone() {
      return getTimezone()
    },
  },
  created() {
    if (this.isCreate) {
      this.$store.dispatch('menu/updateDisplayMode', config.menuStatus.draft)
    } else {
      this.$store.dispatch(
        'menu/updateDisplayMode',
        config.menuStatus.inOperation
      )
      this.editDisabled = true
    }
    if (this.menu.startAt !== null) {
      this.startAt = global.moment(this.menu.startAt).format('YYYY-MM-DDTHH:mm')
    }
    this.endAt = global.moment(this.menu.endAt).format('YYYY-MM-DDTHH:mm')
    this.menuStatus = this.menu.status
  },
  methods: {
    // カレントカテゴリーの変更
    updateCurrentCategory: function(categoryCode) {
      this.$store.dispatch('menu/updateCurrentCategoryCode', categoryCode)
    },
    // 商品選択モーダルの表示
    showItemSelectModal: function() {
      this.$store.dispatch('menu/updateIsShowItemSelectModal', true)
    },
    // プレビューモーダルの表示
    showPreviewModal: function() {
      this.$store.dispatch('menu/updateIsShowPreviewModal', true)
    },
    // 更新
    submit: function() {
      if (!window.confirm(this.$t('orderPage.registrationConfirmation'))) {
        return false
      }
      const params = {
        status: this.menuStatus,
        startAt: this.startAt
          ? global.moment(this.startAt).format('YYYY-MM-DD HH:mm:ss')
          : '',
        endAt: this.endAt
          ? global.moment(this.endAt).format('YYYY-MM-DD HH:mm:ss')
          : '',
        menuCategoryList: this.menu.menuCategoryList,
      }

      // 更新処理
      const request = new MenuRequest()
      request
        .update(this.menu.menuId, params)
        .then(() => {
          this.alerts = 'success'
        })
        .catch((err) => {
          if (typeof err.response.data === 'object') {
            this.errors = [err.response.data]
          } else {
            this.errors = err.response.data
          }
          this.alerts = 'error'
          console.log(err.response)
        })
        .finally(() => {
          this.isSuccess = true
        })
    },
    closeAlert: function() {
      this.isSuccess = false
    },
    csvDownLoad: function() {
      const items = this.menu.menuCategoryList.flatMap((category) =>
        category.itemList.map((item) => [
          category.categoryId,
          item.itemCode,
          item.name,
          item.unVisibleFlag,
          item.wideView,
        ])
      )
      const header = [
        [
          this.$t('common.categoryId'),
          this.$t('orderPage.itemCode'),
          this.$t('orderPage.itemName'),
          this.$t('orderPage.displayMenu'),
          this.$t('orderPage.displayWide'),
        ],
      ]
      const content = header.concat(items)
      const config = {
        delimiter: ',',
        header: true,
        newline: '\r\n',
      }
      // 区切り文字へ変換
      const delimiterString = Papa.unparse(content, config)
      // blobへの変換
      const blob = new Blob([delimiterString], { type: 'text/csv' })
      this.csvFileName = 'menulist'
      this.csvURL = (window.URL || window.webkitURL).createObjectURL(blob)
    },
  },
}
</script>
<style scoped>
.p-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  visibility: hidden;
  opacity: 0;
  z-index: -1;
}
.is-open {
  visibility: visible;
  opacity: 1;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
}
.bbn {
  border-bottom: none !important;
}
</style>
